module.exports = __webpack_public_path__ + "992f72d9950af4ea0700bd45480c5f1e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/nose.png
// module id = z+Gp
// module chunks = 0